import React from 'react';
import AnantTradeCenter from './AnantTradeCenter';

export default function AtcB2B() {
  return <AnantTradeCenter dealType="B2B_BULK" />;
}
